import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type StepperState = {
  isMicrositeDataValid: boolean;
  redirectRoute: string;
};

const initialState: StepperState = {
  isMicrositeDataValid: true,
  redirectRoute: '',
};

export const stepperSlice = createSlice({
  name: 'stepperSlice',
  initialState,
  reducers: {
    setIsMicrositeDataValid(state, action: PayloadAction<boolean>) {
      state.isMicrositeDataValid = action.payload;
    },
    setRedirectRoute(state, action: PayloadAction<string>) {
      state.redirectRoute = action.payload;
    },
  },
});

export default stepperSlice.reducer;
